import { Select, SelectProps, forwardRef } from "@chakra-ui/react";
import states from "utils/usStatesData";

const StateSelect = forwardRef<SelectProps, "select">(
  ({ value, ...rest }, ref) => (
    <Select ref={ref} value={value || ""} {...rest}>
      {states.map((state) => (
        <option key={state.abbreviation} value={state.abbreviation}>
          {state.name}
        </option>
      ))}
    </Select>
  ),
);

export default StateSelect;
